import { $axios } from '../util/axios';

export function createViewsetStoreModule({ url: apiURL, baseURL }) {
  let abortController = null;

  return {
    namespaced: true,
    state: () => ({
      results: [],
      count: 0,
      query: { }
    }),
    mutations: {
      query(state, query) {
        state.query = query;
      },
      viewset(state, viewset) {
        state.results = viewset.results;
        state.count = viewset.count;
      },
    },
    actions: {
      async fetch({ commit, rootState }, query = { page: 1 }) {
        // Abort previous requests
        if (abortController) {
          abortController.abort();
        }
        abortController = new AbortController();

        // Create url based on page and query parameters
        let url = apiURL + '?';
        Object.keys(query).forEach(q => {
          url += `${q}=${query[q]}&`;
        })

        try {
          // Request
          const { data: viewset } = await $axios({
            countryCode: rootState.countryCode,
            baseURL
          }).get(url.slice(0, -1), {
            signal: abortController.signal,
          });
          abortController = null;

          // Commit new data
          commit('query', query);
          commit('viewset', viewset);
        } catch (err) {
          if (err.message !== 'canceled') {
            console.error('Error fetching viewset', err);
          }
        }
      },
    },
  };
}
